module.exports = __webpack_public_path__ + "static/img/default.b4e543ee.jpg";